export default {
  "trendingDetails": "Details",
  "trendingCover": "Cover",
  "trendingLiftCoverHint": "Lift the cover to see details",
  "trendingLowerCoverHint": "Put the cover back",
  "trendingLastPlayed": "Last played",
  "trendingGenres": "Genres",
  "trendingMediaType": "Type",
  "abandonedWhenGiveUp": "When people give up",
  "abandonedDropOffPeak": "Most viewers give up {{range}}",
  "abandonedThresholdHint": "Give up before this much",
  "abandonedIntro": "Items where viewers stop before {{threshold}}% completion",
  "abandonedByMediaType": "By media type",
  "abandonedByLibrary": "By library",
  "abandonedMedianDropOff": "Median drop-off",
  "abandonedConfidence": "Confidence",
  "abandonedNoneRecorded": "No abandonment recorded",
  "abandonedRateLabel": "Abandon rate",
  "abandonedThresholdLabel": "Threshold",
  "abandonedGaveUpAt": "Gave up at {{at}} of {{runtime}}",
  "allMedia": "All Media",
  "movies": "Movies",
  "episodes": "Episodes",
  "liveTV": "Live TV",
  "allMethods": "All Methods",
  "directPlay": "Direct Play",
  "directStream": "Direct Stream",
  "transcode": "Transcode",
  "allServers": "All Servers",
  "serverType": "Server type",
  "mediaType": "Media type",
  "playMethod": "Play method",
  "refreshAnalytics": "Refresh analytics",
  "refresh": "Refresh",
  "totalWatchTime": "Total Watch Time",
  "sessions": "Sessions",
  "overview": "Overview",
  "intelligence": "Intelligence",
  "loadingAnalytics": "Loading analytics...",
  "noWatchSessionDataYet": "No watch session data yet",
  "dataWillAppearOnceUsersStartStreamingContent": "Data will appear once users start streaming content",
  "liveTVSources": "Live TV Sources",
  "watchTimeTrend": "Watch Time Trend",
  "topUsers": "Top Users",
  "topTitles": "Top Titles",
  "recentPlays": "Recent Plays",
  "noChartDataForThisPeriod": "No chart data for this period",
  "streamTypeDistribution": "Stream Type Distribution",
  "noUserDataAvailable": "No user data available",
  "user": "User",
  "time": "Time",
  "avg": "Avg %",
  "noTitleDataAvailable": "No title data available",
  "title": "Title",
  "plays": "Plays",
  "direct": "Direct",
  "stream": "Stream",
  "noRecentPlays": "No recent plays",
  "exportData": "Export Data",
  "cSV": "CSV",
  "bothEmbyJellyfin": "Both (Emby + Jellyfin)",
  "fetchingUsers": "Fetching users",
  "fetchingPlayedItems": "Fetching played items",
  "enrichingWithMediaData": "Enriching with media data",
  "insertingSessions": "Inserting sessions",
  "complete": "Complete",
  "noMediaServersConfiguredConfigurePlexEmbyOrJellyfin": "No media servers configured. Configure Plex, Emby, or Jellyfin in Connection Settings above.",
  "importServerSelection": "Import server selection",
  "enableDatabaseEnrichment": "Enable database enrichment",
  "enrichWithMediaQualityData": "Enrich with media quality data",
  "readsLocalMediaServerDatabaseForCodecResolutionBitrate": "Reads local media server database for codec, resolution, bitrate, and genre data. Requires the media server to be on the same machine.",
  "discoveringDatabasePaths": "Discovering database paths...",
  "couldNotFindDatabaseFilesEnsureTheMediaServer": "Could not find database files. Ensure the media server is installed via QuickBox.",
  "processing": "Processing:",
  "users": "Users:",
  "items": "Items",
  "inserted": "Inserted",
  "skipped": "Skipped",
  "cancelling": "Cancelling...",
  "cancelImport": "Cancel Import",
  "importFailed": "Import Failed",
  "importComplete": "Import Complete",
  "dismiss": "Dismiss",
  "inserted2": "inserted",
  "skipped2": "skipped",
  "in": "in",
  "importedSessions": "Imported sessions:",
  "clearImportedData": "Clear imported data",
  "thisWillPermanentlyRemoveAllImportedHistoricalSessionsFrom": "This will permanently remove all imported historical sessions from analytics. This action cannot be undone.",
  "clearData": "Clear Data",
  "importPlaybackHistoryFromYourPlexEmbyOrJellyfin": "Import playback history from your Plex, Emby, or Jellyfin server to populate analytics with historical data. This reads played items via the media server API and creates synthetic watch sessions.",
  "importFrom": "Import from",
  "selectAServerAboveToConfigureImportOptions": "Select a server above to configure import options.",
  "startImport": "Start Import",
  "clearImportedData2": "Clear Imported Data",
  "tVShows": "TV Shows",
  "music": "Music",
  "other": "Other",
  "mediaPoster": "Media poster",
  "unknown": "Unknown",
  "stopPlayback": "Stop Playback",
  "killSession": "Kill Session",
  "resume": "Resume",
  "pause": "Pause",
  "resumePlayback": "Resume playback",
  "pausePlayback": "Pause playback",
  "stopPlayback2": "Stop playback",
  "sendMessage": "Send Message",
  "sendMessage2": "Send message",
  "mirrorPlayback": "Mirror Playback",
  "mirrorPlayback2": "Mirror playback",
  "killSession2": "Kill session",
  "paused": "Paused",
  "playing": "Playing",
  "idle": "Idle",
  "stopping": "Stopping",
  "client": "Client",
  "device": "Device:",
  "original": "Original:",
  "deviceID": "Device ID:",
  "iP": "IP:",
  "collapseGeoDetails": "Collapse geo details",
  "viewGeoDetails": "View geo details",
  "localNetwork": "Local network",
  "lAN": "LAN",
  "torExitNode": "Tor exit node",
  "tor": "Tor",
  "vPNConnection": "VPN connection",
  "proxyConnection": "Proxy connection",
  "proxy": "Proxy",
  "hostingDatacenter": "Hosting/datacenter",
  "dC": "DC",
  "standardISP": "Standard ISP",
  "iSP": "ISP",
  "location": "Location:",
  "source": "Source",
  "video": "Video",
  "audio": "Audio",
  "method": "Method:",
  "status": "Status",
  "deviceInfo": "Device Info",
  "streamInfo": "Stream Info",
  "actions": "Actions",
  "justNow": "Just now",
  "failedToUpdateDeviceName": "Failed to update device name",
  "deviceNameUpdatedAndSyncedToServer": "Device name updated and synced to server",
  "deviceNameUpdatedLocally": "Device name updated locally",
  "deviceNameUpdated": "Device name updated",
  "active": "Active",
  "inactive": "Inactive",
  "closeDeviceDetails": "Close device details",
  "customName": "Custom Name",
  "customDeviceName": "Custom device name",
  "clearCustomName": "Clear custom name",
  "setAFriendlyNameForThisDevice": "Set a friendly name for this device.",
  "saveName": "Save Name",
  "previousNames": "Previous names:",
  "watchStatistics": "Watch Statistics",
  "loading": "Loading...",
  "watchTime": "Watch Time",
  "users2": "Users",
  "noStatisticsAvailable": "No statistics available",
  "recentlyWatched": "Recently Watched",
  "noWatchHistory": "No watch history",
  "deviceInformation": "Device Information",
  "deviceName": "Device Name",
  "deviceID2": "Device ID",
  "platform": "Platform",
  "clientVersion": "Client Version",
  "iPAddress": "IP Address",
  "connections": "Connections",
  "firstSeen": "First Seen",
  "lastSeen": "Last Seen",
  "userAgent": "User Agent",
  "lastSeen2": "-- last seen",
  "sessions2": "sessions)",
  "lastSeen3": "Last seen:",
  "clear": "Clear",
  "save": "Save",
  "resetViewToMarker": "Reset view to marker",
  "preFilledFromSessionRemoveOrAdjustValuesAs": "Pre-filled from session. Remove or adjust values as needed.",
  "geoLockRuleCreated": "Geo-lock rule created",
  "failedToCreateRule": "Failed to create rule",
  "localNetwork2": "Local Network",
  "privateIPNoGeolocationAvailable": "Private IP - no geolocation available",
  "closeGeoDetails": "Close geo details",
  "vPNConnectionDetected": "VPN connection detected",
  "proxyConnectionDetected": "Proxy connection detected",
  "torExitNodeDetected": "Tor exit node detected",
  "hostingDatacenterIP": "Hosting/datacenter IP",
  "hosting": "Hosting",
  "standardISPConnection": "Standard ISP connection",
  "locationDetails": "Location Details",
  "country": "Country",
  "region": "Region",
  "city": "City",
  "coordinates": "Coordinates",
  "geoLockActions": "Geo Lock Actions",
  "createAGeoLockRuleForThisIPAddress": "Create a geo lock rule for this IP address",
  "lockIP": "Lock IP",
  "createAGeoLockRuleForThisCountry": "Create a geo lock rule for this country",
  "lockCountry": "Lock Country",
  "iPHistory": "IP History",
  "noIPChangesRecorded": "No IP changes recorded",
  "10kmAccuracyIPBased": "~10km accuracy (IP-based)",
  "coordinatesUnavailable": "Coordinates unavailable",
  "resetView": "Reset view",
  "createAGeoLockRuleForThisIP": "Create a geo lock rule for this IP",
  "unknownLocation": "Unknown location",
  "geoPlaybackHeatmap": "Geo playback heatmap",
  "noLocationDataInThisPeriod": "No location data in this period",
  "sessions3": "sessions",
  "clickMarkersForDetails": "Click markers for details",
  "gPUTelemetry": "GPU Telemetry",
  "gPUTelemetryTimeRange": "GPU telemetry time range",
  "unlockYAxisDynamicScale": "Unlock Y-axis (dynamic scale)",
  "lockYAxisAt100": "Lock Y-axis at 100%",
  "unlockYAxisToDynamicScale": "Unlock Y-axis to dynamic scale",
  "chartLegend": "Chart legend",
  "showChartLegend": "Show chart legend",
  "zoomIn": "Zoom in",
  "zoomOut": "Zoom out",
  "resetZoom": "Reset zoom",
  "freq": "Freq",
  "temp": "Temp",
  "connectingToGPUStream": "Connecting to GPU stream...",
  "noIntelIGPUTelemetryAvailable": "No Intel iGPU telemetry available",
  "gPUStreamError": "GPU stream error",
  "trending": "Trending",
  "library": "Library",
  "abandoned": "Abandoned",
  "loadingIntelligenceData": "Loading intelligence data...",
  "noIntelligenceDataYet": "No intelligence data yet",
  "itemAnalyticsWillAppearOnceWatchSessionsAreRecorded": "Item analytics will appear once watch sessions are recorded",
  "searchTitles": "Search titles...",
  "searchMediaTitles": "Search media titles",
  "mediaItems": "Media items",
  "compl": "Compl.",
  "health": "Health",
  "noItemsFound": "No items found",
  "closeItemDetail": "Close item detail",
  "viewers": "Viewers",
  "avgComp": "Avg Comp.",
  "playbackMethods": "Playback Methods",
  "resolutions": "Resolutions",
  "topViewers": "Top Viewers",
  "completed": "Completed",
  "x": "× ·",
  "first": "First:",
  "last": "Last:",
  "library2": "Library:",
  "noTrendingDataAvailable": "No trending data available",
  "trendingScoresAreCalculatedFromRecentWatchActivity": "Trending scores are calculated from recent watch activity",
  "viewTrendingMetrics": "View trending metrics",
  "hideTrendingDetails": "Hide trending details",
  "viewTrendingDetails": "View trending details",
  "closeMetrics": "Close metrics",
  "closeDetails": "Close details",
  "type": "Type",
  "noLibraryDataAvailable": "No library data available",
  "libraryStatsAppearOnceMediaItemsArePlayed": "Library stats appear once media items are played",
  "highCompletion": "High completion",
  "midCompletion": "Mid completion",
  "lowCompletion": "Low completion",
  "unknownLibrary": "Unknown Library",
  "items2": "items",
  "completionRange": "Completion range",
  "noAbandonedContentFound": "No abandoned content found",
  "contentWithUnder10CompletionWillAppearHere": "Content with under 10% completion will appear here",
  "itemsWhereViewersStopBefore10Completion": "Items where viewers stop before 10% completion",
  "plays2": "plays",
  "filter": "Filter:",
  "all": "All",
  "recentlyAdded": "Recently Added",
  "whatSNew": "What's New",
  "movie": "Movie",
  "episode": "Episode",
  "aired": "Aired:",
  "added": "Added:",
  "rating": "Rating:",
  "failedToUpdateRating": "Failed to update rating",
  "failedToUpdateFavorite": "Failed to update favorite",
  "addedToFavorites": "Added to favorites",
  "removedFromFavorites": "Removed from favorites",
  "noItems": "No items",
  "closePosterView": "Close poster view",
  "subject": "Subject",
  "leaveBlankToUseDefault": "(leave blank to use default)",
  "message": "Message",
  "enterYourMessage": "Enter your message...",
  "cancel": "Cancel",
  "send": "Send",
  "userAdminPanel": "User Admin Panel",
  "thisSessionIsRoutedThroughAVPNSoThe": "This session is routed through a VPN, so the real viewer IP and location are not available.",
  "vPNRoutedClientIPUnavailable": "VPN-routed — client IP unavailable",
  "limbo": "Limbo",
  "stop": "Stop",
  "sessionControls": "Session controls",
  "closeSessionControls": "Close session controls",
  "openSessionControls": "Open session controls",
  "transcoding": "Transcoding",
  "close": "Close",
  "noActiveStreams": "No Active Streams",
  "streamsWillAppearHereWhenUsersStartPlayingMedia": "Streams will appear here when users start playing media on your servers.",
  "sD": "SD",
  "stereo": "Stereo",
  "mono": "Mono",
  "noMediaPlaying": "No media playing",
  "client2": "Client:",
  "source2": "Source:",
  "stream2": "Stream:",
  "video2": "Video:",
  "audio2": "Audio:",
  "status2": "Status:",
  "stopNotSupportedByThisClient": "Stop not supported by this client",
  "filterUsers": "Filter users...",
  "filterDevices": "Filter devices...",
  "searchSessions": "Search sessions...",
  "containerNotSupported": "Container not supported",
  "videoCodecNotSupported": "Video codec not supported",
  "audioCodecNotSupported": "Audio codec not supported",
  "subtitleCodecNotSupported": "Subtitle codec not supported",
  "externalAudio": "External audio",
  "secondaryAudioNotSupported": "Secondary audio not supported",
  "videoProfileNotSupported": "Video profile not supported",
  "videoLevelNotSupported": "Video level not supported",
  "videoBitDepthNotSupported": "Video bit depth not supported",
  "resolutionNotSupported": "Resolution not supported",
  "referenceFramesNotSupported": "Reference frames not supported",
  "anamorphicVideoNotSupported": "Anamorphic video not supported",
  "interlacedVideoNotSupported": "Interlaced video not supported",
  "audioChannelsNotSupported": "Audio channels not supported",
  "audioProfileNotSupported": "Audio profile not supported",
  "audioSampleRateNotSupported": "Audio sample rate not supported",
  "audioBitDepthNotSupported": "Audio bit depth not supported",
  "bitrateExceedsLimit": "Bitrate exceeds limit",
  "videoBitrateNotSupported": "Video bitrate not supported",
  "audioBitrateNotSupported": "Audio bitrate not supported",
  "unknownVideoStream": "Unknown video stream",
  "unknownAudioStream": "Unknown audio stream",
  "directPlayError": "Direct play error",
  "videoRangeTypeNotSupported": "Video range type not supported",
  "container": "Container",
  "videoBitrate": "Video Bitrate",
  "audioBitrate": "Audio Bitrate",
  "subtitle": "Subtitle",
  "totalBitrate": "Total Bitrate",
  "transcoded": "Transcoded",
  "bitrate": "Bitrate",
  "framerate": "Framerate",
  "hWAccel": "HW Accel",
  "transcodeReasons": "Transcode Reasons",
  "noStreamDetailsAvailable": "No stream details available",
  "streamDetails": "Stream details",
  "live": "Live",
  "offline": "Offline",
  "activeStreams": "Active Streams",
  "gPU": "GPU",
  "mHz": "MHz",
  "totalBandwidthAcrossAllStreams": "Total bandwidth across all streams",
  "bandwidth": "Bandwidth",
  "connecting": "Connecting",
  "reconnecting": "Reconnecting",
  "disconnected": "Disconnected",
  "disabled": "Disabled",
  "streamingDashboard": "Streaming Dashboard",
  "mediaServerIsSlowToRespondShowingLastKnown": "Media server is slow to respond. Showing last known sessions.",
  "serverSlow": "Server Slow",
  "reconnect": "Reconnect",
  "watchAnalytics": "Watch Analytics",
  "streamingSettings": "Streaming Settings",
  "wSDActivityLogs": "WSD Activity Logs",
  "viewMode": "View mode",
  "grouped": "Grouped",
  "cards": "Cards",
  "table": "Table",
  "never": "Never",
  "accountInfo": "Account Info",
  "lastLogin": "Last Login",
  "lastActivity": "Last Activity",
  "remoteAccess": "Remote Access",
  "streamLimit": "Stream Limit",
  "bitrateLimit": "Bitrate Limit",
  "topLibraries": "Top Libraries",
  "allTimeStatistics": "All-Time Statistics",
  "avgCompletion": "Avg Completion",
  "devices": "Devices",
  "titles": "Titles",
  "topGenres": "Top Genres",
  "historyTimeRange": "History time range",
  "noDeviceID": "No device ID",
  "noWatchHistoryInThisPeriod": "No watch history in this period",
  "bypassEnabledUserWillSkipPauseWarningsAndAuto": "Bypass enabled -- user will skip pause warnings and auto-stops",
  "bypassDisabledUserIsSubjectToEnforcementRules": "Bypass disabled -- user is subject to enforcement rules",
  "failedToUpdateUserPolicy": "Failed to update user policy",
  "loadingUserProfile": "Loading user profile...",
  "failedToLoadProfile": "Failed to load profile",
  "closeUserDrawer": "Close user drawer",
  "admin": "Admin",
  "hidden": "Hidden",
  "bypassKillStream": "Bypass kill stream",
  "whenEnabledThisUserWonTReceivePauseWarnings": "When enabled, this user won't receive pause warnings or automatic stops.",
  "exceptionsTranscodingAndLiveTVSessionsAreAlwaysEnforced": "Exceptions: transcoding and Live TV sessions are always enforced.",
  "toggleBypassKillStreamForThisUser": "Toggle bypass kill stream for this user",
  "bypassIsIgnoredForTranscodingAndLiveTVEnforcement": "Bypass is ignored for transcoding and Live TV — enforcement rules still apply.",
  "enforced": "Enforced",
  "thisUserBypassesAutomaticKillStreamEnforcementExceptFor": "This user bypasses automatic kill stream enforcement (except for transcoding and Live TV sessions)",
  "bypass": "Bypass",
  "x2": "× ·",
  "play": "Play",
  "notify": "Notify",
  "disconnect": "Disconnect",
  "killDevice": "Kill Device",
  "policyChange": "Policy Change",
  "action": "Action",
  "allActions": "All Actions",
  "filterByUser": "Filter by user...",
  "deleteLogsOlderThan7Days": "Delete logs older than 7 days",
  "7d": "> 7d",
  "deleteLogsOlderThan30Days": "Delete logs older than 30 days",
  "30d": "> 30d",
  "deleteAllLogs": "Delete all logs",
  "deleteAll": "Delete All",
  "refreshLogs": "Refresh logs",
  "deleteAllLogs2": "Delete All Logs",
  "logsDeleted": "Logs deleted",
  "unknownError": "Unknown error",
  "failedToDeleteLogs": "Failed to delete logs",
  "deleteOldLogs": "Delete Old Logs",
  "delete": "Delete",
  "logsPruned": "Logs pruned",
  "failedToPruneLogs": "Failed to prune logs",
  "device2": "Device",
  "loadingLogs": "Loading logs...",
  "noLogsFound": "No logs found",
  "tryAdjustingYourFilters": "Try adjusting your filters",
  "logsWillAppearAsStreamingActionsOccur": "Logs will appear as streaming actions occur",
  "rateThisItem": "Rate this item",
  "removeFromFavorites": "Remove from favorites",
  "addToFavorites": "Add to favorites",
  "mediaItemActions": "Media item actions",
  "markAsUnwatched": "Mark as unwatched",
  "markAsWatched": "Mark as watched",
  "markAsUnwatched2": "Mark as Unwatched",
  "markAsWatched2": "Mark as Watched",
  "yourRating": "Your rating",
  "favorite": "Favorite",
  "moreActions": "More actions",
  "uSR": "USR",
  "dEV": "DEV",
  "rES": "RES",
  "cOD": "COD",
  "bIT": "BIT",
  "mTD": "MTD",
  "nOW": "NOW",
  "pAUSED": "PAUSED",
  "lIVE": "LIVE",
  "eNDED": "ENDED",
  "tTL": "TTL",
  "copied": "Copied!",
  "copyStats": "Copy stats",
  "copyNerdStatsToClipboard": "Copy nerd stats to clipboard",
  "hLSPlaybackIsNotSupportedInThisBrowser": "HLS playback is not supported in this browser.",
  "sessionEnded": "Session Ended",
  "theSourcePlaybackSessionHasEnded": "The source playback session has ended.",
  "mirrorExpired": "Mirror Expired",
  "tokenExpiredStartANewMirrorToContinue": "Token expired. Start a new mirror to continue.",
  "playbackError": "Playback Error",
  "theMirrorStreamCouldNotBePlayedTryStarting": "The mirror stream could not be played. Try starting it again.",
  "restoreMirrorPlayer": "Restore mirror player",
  "closeMirror": "Close mirror",
  "mirror": "Mirror",
  "mirrorPlaybackViewer": "Mirror playback viewer",
  "dragToRepositionPlayer": "Drag to reposition player",
  "hideStats": "Hide stats",
  "showStats": "Show stats",
  "hideNerdStats": "Hide nerd stats",
  "showNerdStats": "Show nerd stats",
  "restore": "Restore",
  "fillContentArea": "Fill content area",
  "restoreToFloating": "Restore to floating",
  "minimize": "Minimize",
  "minimizeToTab": "Minimize to tab",
  "sourcePaused": "Source Paused",
  "syncError": "Sync error",
  "seekPosition": "Seek position",
  "unmute": "Unmute",
  "mute": "Mute",
  "failedToDiscoverDatabasePaths": "Failed to discover database paths",
  "historicalImportStarted": "Historical import started",
  "failedToStartImport": "Failed to start import",
  "importCancellationRequested": "Import cancellation requested",
  "failedToCancelImport": "Failed to cancel import",
  "failedToClearImportedData": "Failed to clear imported data",
  "failedToResetAnalytics": "Failed to reset analytics",
  "youMustBeSignedInToCheckForDuplicate": "You must be signed in to check for duplicate guide IDs.",
  "couldnTCheckForDuplicateGuideIDs": "Couldn't check for duplicate guide IDs.",
  "couldnTReachTheServerCheckYourConnectionAnd": "Couldn't reach the server. Check your connection and try again.",
  "youMustBeSignedInToReSyncThe": "You must be signed in to re-sync the channel map.",
  "couldnTReSyncTheChannelMap": "Couldn't re-sync the channel map.",
  "sSENotSupportedInThisBrowser": "SSE not supported in this browser",
  "invalidGPUStreamPayload": "Invalid GPU stream payload",
  "gPUStreamDisconnected": "GPU stream disconnected",
  "syncFailed": "Sync failed",
  "networkError": "Network error",
  "failedToLoadDevices": "Failed to load devices",
  "failedToRenameDevice": "Failed to rename device",
  "failedToDeleteDevice": "Failed to delete device",
  "failedToUpdateDeviceLock": "Failed to update device lock",
  "failedToSyncDeviceNames": "Failed to sync device names",
  "failedToScanForStaleDevices": "Failed to scan for stale devices",
  "deviceWasAlreadyRemovedFromTheMediaServer": "Device was already removed from the media server",
  "deviceRemovedFromTheMediaServer": "Device removed from the media server",
  "failedToRemoveDeviceFromTheMediaServer": "Failed to remove device from the media server",
  "failedToLoadStreamingUsers": "Failed to load streaming users",
  "failedToLoadUserProfile": "Failed to load user profile",
  "failedToLoadWatchHistory": "Failed to load watch history",
  "failedToLoadAnalytics": "Failed to load analytics",
  "failedToLoadIntelligenceData": "Failed to load intelligence data",
  "failedToLoadLibraryData": "Failed to load library data",
  "failedToLoadLibraryCounts": "Failed to load library counts",
  "eventSourceNotSupported": "EventSource not supported",
  "wSDNotEnabled": "WSD not enabled",
  "connectionLost": "Connection lost",
  "failedToSendMessage": "Failed to send message",
  "messageSent": "Message sent",
  "failedToStopPlayback": "Failed to stop playback",
  "playbackStopped": "Playback stopped",
  "failedToKillSession": "Failed to kill session",
  "sessionTerminated": "Session terminated",
  "failedToPausePlayback": "Failed to pause playback",
  "playbackPaused": "Playback paused",
  "failedToResumePlayback": "Failed to resume playback",
  "playbackResumed": "Playback resumed",
  "failedToLoadLogs": "Failed to load logs",
  "failedToClearLogs": "Failed to clear logs",
  "alertOnly": "Alert Only",
  "softBlock": "Soft Block",
  "hardBlock": "Hard Block",
  "logViolationAllowPlayback": "Log violation, allow playback",
  "showWarningAllowPlayback": "Show warning, allow playback",
  "killSessionImmediately": "Kill session immediately",
  "alert": "Alert",
  "theMirrorCouldNotBeStarted": "The mirror could not be started.",
  "mirrorUnavailable": "Mirror unavailable",
  "couldNotReachTheMirrorServicePleaseTryAgain": "Could not reach the mirror service. Please try again.",
  "wSDashboardIsNotEnabled": "WSDashboard is not enabled",
  "featureNotEnabled": "Feature Not Enabled",
  "theStreamingDashboardFeatureIsDisabled": "The Streaming Dashboard feature is disabled.",
  "connectionIssue": "Connection Issue",
  "retry": "Retry",
  "plexInstalledAlmostReady": "Plex installed — almost ready",
  "quickBoxInstalledPlexButDidnTCaptureYourX": "QuickBox installed Plex but didn't capture your X-Plex-Token yet. Open Settings to paste your token (find it in plex.tv → Account → Authorized Devices) and finish the setup.",
  "openPlexSettings": "Open Plex Settings",
  "configureYourMediaServers": "Configure Your Media Servers",
  "connectYourEmbyJellyfinOrPlexServerToStart": "Connect your Emby, Jellyfin, or Plex server to start monitoring active streaming sessions in real-time.",
  "openSettings": "Open Settings",
  "avgCompletionPctAvgCompletion": "{{avgCompletionPct}}% avg completion",
  "directStreamPctDirectStream": "{{directStreamPct}}% direct stream",
  "ofSessionsCountSessions": "of {{sessionsCount}} sessions",
  "importFromLabel": "Import from {{label}}",
  "importProgressPct": "Import progress: {{pct}}%",
  "viewPosterForMedia": "View poster for {{media}}",
  "stopPlaybackForUserNameOnDeviceNameTheStreamWillPause": "Stop playback for {{userName}} on {{deviceName}}? The stream will pause.",
  "disconnectUserNameFromDeviceNameThisWillForciblyEndTheirSession": "Disconnect {{userName}} from {{deviceName}}? This will forcibly end their session.",
  "playbackProgressPercent": "Playback progress: {{percent}}%",
  "collapseDetailsForDeviceName": "Collapse details for {{deviceName}}",
  "viewDetailsForDeviceName": "View details for {{deviceName}}",
  "labelSessions": "{{label}} sessions",
  "serverSyncFailedUpstreamError": "Server sync failed: {{upstreamError}}",
  "labelMap": "{{label}} map",
  "noItemsMatchingSearch": "No items matching \"{{search}}\"",
  "browseTheNameLibrary": "Browse the {{name}} library",
  "browseAllTotalItemsItemsInName": "Browse all {{totalItems}} items in {{name}}",
  "viewNameItemsRankedByPlays": "View {{name}} items ranked by plays",
  "viewNameItemsRankedByWatchTime": "View {{name}} items ranked by watch time",
  "filterNameByCompletionRange": "Filter {{name}} by completion range",
  "abandonedCountOfTotalPlaysPlaysAbandoned": "{{abandonedCount}} of {{totalPlays}} plays abandoned",
  "activeLabelItems": "{{activeLabel}} items",
  "titleItems": "{{title}} items",
  "labelForElapsed": "{{label}} for {{elapsed}}",
  "posterForTitle": "Poster for {{title}}",
  "openAdminPanelForUserName": "Open admin panel for {{userName}}",
  "totalPausedTotalPauseDurationPauseCountTimes": "Total paused: {{totalPauseDuration}} ({{pauseCount}} times)",
  "stopPlaybackForUserNameOnDeviceName": "Stop playback for {{userName}} on {{deviceName}}?",
  "primaryTitleUserNameOnDeviceName": "{{primaryTitle}} - {{userName}} on {{deviceName}}",
  "deviceValue": "Device: {{value}}",
  "locationValue": "Location: {{value}}",
  "streamingConnectionStatusLabel": "Streaming connection status: {{label}}",
  "collapseProfileForUserName": "Collapse profile for {{userName}}",
  "viewProfileForUserName": "View profile for {{userName}}",
  "deletedEntriesRemoved": "{{deleted}} entries removed",
  "starStars": "Stars: {{star}}",
  "viewOnServerLabel": "View on {{serverLabel}}",
  "fatalHLSErrorDetails": "Fatal HLS error: {{details}}",
  "clearedDeletedImportedSessions": "Cleared {{deleted}} imported sessions",
  "resetAnalyticsDeletedSessionsDeleted": "Reset analytics — {{deleted}} sessions deleted",
  "syncFailedStatus": "Sync failed ({{status}})",
  "requestFailedStatus": "Request failed: {{status}}",
  "chChannelNumberLabel": "Ch {{channelNumberLabel}}",
  "gpuRender": "Render",
  "gpuVideo": "Video",
  "gpuCopy": "Copy",
  "gpuFreq": "Frequency",
  "nA": "N/A",
  "pauseTelemetry": "Pause GPU telemetry",
  "resumeTelemetry": "Resume GPU telemetry",
  "resumeLive": "Resume live",
  "media": "Media",
  "series": "Series",
  "genres": "Genres:",
  "error": "Error",
  "failedWatched": "Failed to mark item as watched",
  "failedUnwatched": "Failed to mark item as unwatched",
  "markedWatched": "Marked as watched",
  "markedUnwatched": "Marked as unwatched",
  "ratingRemoved": "Rating removed",
  "ratingSaved": "Rating saved",
  "deleteAllLogsBody": "This will permanently delete all activity logs. This action cannot be undone.",
  "pruneLogsBody": "This will permanently delete all activity logs older than {{days}} days.",
  "enableDashboardGuidance": "Enable WSDashboard in General Settings → Feature Flags to start monitoring your media server streams.",
  "popupRecipient": "Send a popup message to {{user}} on {{device}}",
  "keyboardSend": "Press Ctrl + Enter to send",
  "connectionCount": "Connections: {{count}}",
  "syncToServer": "Sync to {{server}}",
  "channelNumber": "Ch {{channel}}",
  "playingCount": "Playing: {{count}}",
  "activeSessionCount": "Active ({{count}})",
  "deviceCount": "Devices ({{count}})",
  "totalCount": "({{count}} total)",
  "historyErrorDetail": "Watch history: {{detail}}",
  "showingResults": "Showing 50 of {{count}} results",
  "viewOnServer": "View on {{server}}",
  "uniqueUserCount": "Unique users: {{count}}",
  "activeStreamMonitoring": "Real-time monitoring — active streams: {{count}}",
  "configureMediaServers": "Configure media servers to monitor active streams",
  "eventConnected": "Live event stream connected",
  "eventConnecting": "Connecting to event stream...",
  "eventOffline": "Event stream offline",
  "noServerItems": "No {{server}} items",
  "eventStatus": "Event stream: {{status}}",
  "lineupPermission": "You don't have permission to check this lineup.",
  "dispatcharrUnavailable": "Couldn't reach Dispatcharr. Make sure it's running.",
  "duplicateCheckFailed": "Couldn't check for duplicate guide IDs. Please try again.",
  "channelmapPermission": "You don't have permission to re-sync this channel map.",
  "channelmapUnavailable": "Couldn't reach Plex or Dispatcharr. Make sure both are running.",
  "channelmapFailed": "Couldn't re-sync the channel map. Please try again.",
  "lockIpName": "Lock IP {{ip}}{{hint}}",
  "lockCountryName": "Lock {{country}}{{hint}}",
  "deviceIdDetail": "ID: {{id}}",
  "starsCount": "Stars: {{count}}",
  "noServerConfigured": "No {{server}} server is configured or enabled",
  "removalRejected": "The media server rejected the removal",
  "deviceRemovalFailed": "Failed to remove device from the media server",
  "processingUser": "Processing: {{user}}",
  "insertedCount": "Inserted: {{count}}",
  "skippedCount": "Skipped: {{count}}",
  "elapsedValue": "Elapsed: {{time}}",
  "sessionsCountParen": "(Sessions: {{count}})",
  "sessionCountLabel": "Sessions: {{count}}",
  "itemsCount": "Items: {{count}}",
  "playsCount": "Plays: {{count}}",
  "liveProgrammesCount": "{{count}} programmes",
  "librarySummary": "Movies: {{movies}} · Series: {{series}} · Episodes: {{episodes}}",
  "channelShort": "CH#",
  "completion": "Completion",
  "uniqueTitles": "Unique Titles",
  "uniqueViewers": "Unique Viewers",
  "lastWatched": "Last watched",
  "lastPlayed": "Last played",
  "favouriteTitle": "Favourite",
  "sectionUnavailable": "This section couldn't be displayed.",
  "topTitlesLiveTvHint": "Live TV is not ranked in Top Titles. See the TV Guide trends for live channel activity.",
  "topTitlesRankingHint": "Ranked by how many people watched each title and how much of it they finished. Runtime does not count.",
  "topTitlesMediaTypeLabel": "Top Titles media type",
  "topTitlesFollowingFilter": "Following the media type filter",
  "episodesWatched": "Episodes watched",
  "trendingServers": "Servers",
  "openProfileForUserName": "Open profile for {{userName}}",
  "openDevicePageForDeviceName": "Open device page for {{deviceName}}",
  "openTvGuideForSource": "Open TV Guide filtered to {{source}}"
} as const;
